// AUTO-GENERATED -- do not edit manually
// Generated by scripts/generate-app-version.js
export const APP_VERSION = {
  version: '1.59.2',
  buildDate: '2026-10-22T10:20:07Z',
} as const;
